import { Company } from "../../../../../redux/features/user/types/userState.types";
import { normalizeCompanyNameToSlug } from "../../project/helpers/normalize-company-to-slug.helper";

let _getCompany: (() => Company) | null = null;

export function bindCompanyProvider(getter: () => any) {
    _getCompany = getter;
}

export function getCompanySafe(): { companyId: string; companySlug: string, coverageAreas: any[] } | null {
    const c = _getCompany?.() ?? null;
    console.log(c)

    // if (!c?.id || !c?.name || !c?.coverageAreas?.length) return null;

    return {
        companyId: "",
        companySlug: "",
        coverageAreas: [],
        // companyId: String(c?.id),
        // companySlug: normalizeCompanyNameToSlug(c?.name),
        // coverageAreas: c?.coverageAreas || [],
    };
}

export function requireCompany() {

    const result = getCompanySafe() ?? { companyId: "", companySlug: "", coverageAreas: [] };

    return result;
}